/* Greedsweeper - Custom Minesweeper Game */

class Greedsweeper {
  constructor() {
    this.rows = 11;
    this.cols = 11;
    this.totalDevils = 15;
    this.board = [];
    this.revealed = [];
    this.flagged = [];
    this.gameOver = false;
    this.moneyCollected = 0;
    this.gameWindow = null;
    this.playerName = null;
    this.gameScores = [];
  }

  async init() {
    // Check if player has a name saved
    const nameForm = document.getElementById('name-entry-form');
    const gameArea = document.getElementById('game-area');
    
    if (!this.playerName) {
      await this.promptForName();
    } else {
      // Player name exists, just load scores and show game area
      await this.loadPlayerScores();
      if (nameForm) nameForm.style.display = 'none';
      if (gameArea) gameArea.style.display = 'block';
      
      // If guest, hide submit button
      if (this.playerName === 'GUEST') {
        const submitScoreBtn = document.getElementById('submit-score');
        if (submitScoreBtn) {
          submitScoreBtn.style.display = 'none';
        }
      }
    }
    
    this.createBoard();
    this.calculateNumbers();
    this.renderGame();
    this.updateScoreDisplay();
  }

  async promptForName() {
    return new Promise((resolve) => {
      const nameForm = document.getElementById('name-entry-form');
      const nameInput = document.getElementById('player-name-input');
      const submitBtn = document.getElementById('submit-name-btn');
      const playWithoutBtn = document.getElementById('play-without-name-btn');
      const gameArea = document.getElementById('game-area');
      
      if (!nameForm || !nameInput || !submitBtn || !gameArea) {
        this.playerName = 'PLAYER';
        this.loadPlayerScores().then(resolve);
        return;
      }

      nameForm.style.display = 'block';
      gameArea.style.display = 'none';

      submitBtn.onclick = async () => {
        const name = nameInput.value.trim();
        if (name) {
          this.playerName = name.substring(0, 20).toUpperCase();
          await this.loadPlayerScores();
          nameForm.style.display = 'none';
          gameArea.style.display = 'block';
          resolve();
        } else {
          alert('Please enter your Instagram username!');
        }
      };

      playWithoutBtn.onclick = async () => {
        this.playerName = 'GUEST';
        this.gameScores = [];
        nameForm.style.display = 'none';
        gameArea.style.display = 'block';
        // Hide submit score button for guests
        const submitScoreBtn = document.getElementById('submit-score');
        if (submitScoreBtn) {
          submitScoreBtn.style.display = 'none';
        }
        resolve();
      };

      nameInput.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
          submitBtn.click();
        }
      });
    });
  }

  async loadPlayerScores() {
    try {
      const data = localStorage.getItem(`greedsweeper-player-${this.playerName}`);
      if (data) {
        this.gameScores = JSON.parse(data);
      } else {
        this.gameScores = [];
      }
    } catch (error) {
      this.gameScores = [];
    }
  }

  async savePlayerScores() {
    try {
      localStorage.setItem(`greedsweeper-player-${this.playerName}`, JSON.stringify(this.gameScores));
    } catch (error) {
      console.error('Error saving player scores:', error);
    }
  }

  createBoard() {
    this.board = Array(this.rows).fill(null).map(() => Array(this.cols).fill(0));
    this.revealed = Array(this.rows).fill(null).map(() => Array(this.cols).fill(false));
    this.flagged = Array(this.rows).fill(null).map(() => Array(this.cols).fill(false));

    let devilsPlaced = 0;
    while (devilsPlaced < this.totalDevils) {
      const row = Math.floor(Math.random() * this.rows);
      const col = Math.floor(Math.random() * this.cols);
      
      if (this.board[row][col] !== '😈') {
        this.board[row][col] = '😈';
        devilsPlaced++;
      }
    }
  }

  calculateNumbers() {
    for (let row = 0; row < this.rows; row++) {
      for (let col = 0; col < this.cols; col++) {
        if (this.board[row][col] === '😈') continue;
        
        let count = 0;
        for (let dr = -1; dr <= 1; dr++) {
          for (let dc = -1; dc <= 1; dc++) {
            if (dr === 0 && dc === 0) continue;
            const newRow = row + dr;
            const newCol = col + dc;
            
            if (newRow >= 0 && newRow < this.rows && newCol >= 0 && newCol < this.cols) {
              if (this.board[newRow][newCol] === '😈') {
                count++;
              }
            }
          }
        }
        this.board[row][col] = count;
      }
    }
  }

  revealCell(row, col) {
    if (this.gameOver || this.revealed[row][col] || this.flagged[row][col]) return;

    this.revealed[row][col] = true;

    if (this.board[row][col] === '😈') {
      this.gameOver = true;
      this.revealAll();
      this.endGame();
      return;
    }

    this.moneyCollected++;
    this.updateMoneyCounter();

    if (this.board[row][col] === 0) {
      for (let dr = -1; dr <= 1; dr++) {
        for (let dc = -1; dc <= 1; dc++) {
          const newRow = row + dr;
          const newCol = col + dc;
          
          if (newRow >= 0 && newRow < this.rows && newCol >= 0 && newCol < this.cols) {
            this.revealCell(newRow, newCol);
          }
        }
      }
    }

    this.renderGame();
    this.checkWin();
  }

  toggleFlag(row, col) {
    if (this.gameOver || this.revealed[row][col]) return;
    this.flagged[row][col] = !this.flagged[row][col];
    this.renderGame();
  }

  revealAll() {
    for (let row = 0; row < this.rows; row++) {
      for (let col = 0; col < this.cols; col++) {
        this.revealed[row][col] = true;
      }
    }
    this.renderGame();
  }

  checkWin() {
    let safeCells = (this.rows * this.cols) - this.totalDevils;
    let revealedSafe = 0;

    for (let row = 0; row < this.rows; row++) {
      for (let col = 0; col < this.cols; col++) {
        if (this.revealed[row][col] && this.board[row][col] !== '😈') {
          revealedSafe++;
        }
      }
    }

    if (revealedSafe === safeCells) {
      this.gameOver = true;
      this.endGame(true);
    }
  }

  renderGame() {
    const gameBoard = document.getElementById('greedsweeper-board');
    if (!gameBoard) return;

    gameBoard.innerHTML = '';
    gameBoard.style.display = 'grid';
    gameBoard.style.gridTemplateColumns = `repeat(${this.cols}, 20px)`;
    gameBoard.style.gap = '1px';
    gameBoard.style.backgroundColor = '#808080';
    gameBoard.style.padding = '4px';
    gameBoard.style.border = '2px inset #808080';
    gameBoard.style.margin = '0 auto';
    gameBoard.style.width = 'fit-content';

    for (let row = 0; row < this.rows; row++) {
      for (let col = 0; col < this.cols; col++) {
        const cell = document.createElement('div');
        cell.className = 'greedy-cell';
        cell.style.width = '20px';
        cell.style.height = '20px';
        cell.style.display = 'flex';
        cell.style.alignItems = 'center';
        cell.style.justifyContent = 'center';
        cell.style.fontSize = '12px';
        cell.style.fontWeight = 'bold';
        cell.style.cursor = 'pointer';
        cell.style.userSelect = 'none';

        if (this.revealed[row][col]) {
          cell.style.background = '#c0c0c0';
          cell.style.border = '1px solid #808080';
          
          const value = this.board[row][col];
          if (value === '😈') {
            cell.textContent = '😈';
            cell.style.background = '#ff0000';
          } else if (value === 0) {
            cell.textContent = '';
          } else {
            cell.textContent = '$'.repeat(value);
            cell.style.color = this.getNumberColor(value);
            cell.style.fontSize = '10px';
          }
        } else if (this.flagged[row][col]) {
          cell.style.background = '#c0c0c0';
          cell.style.border = '2px solid';
          cell.style.borderColor = '#dfdfdf #808080 #808080 #dfdfdf';
          cell.textContent = '🚩';
        } else {
          cell.style.background = '#c0c0c0';
          cell.style.border = '2px solid';
          cell.style.borderColor = '#dfdfdf #808080 #808080 #dfdfdf';
        }

        cell.addEventListener('click', () => {
          if (!this.gameOver && !this.flagged[row][col]) {
            this.revealCell(row, col);
          }
        });

        cell.addEventListener('contextmenu', (e) => {
          e.preventDefault();
          this.toggleFlag(row, col);
        });

        gameBoard.appendChild(cell);
      }
    }
  }

  getNumberColor(num) {
    const colors = {
      1: '#0000ff', 2: '#008000', 3: '#ff0000', 4: '#000080',
      5: '#800000', 6: '#008080', 7: '#000000', 8: '#808080'
    };
    return colors[num] || '#000000';
  }

  updateMoneyCounter() {
    const counter = document.getElementById('money-counter');
    if (counter) counter.textContent = `$${this.moneyCollected}`;
  }

  updateScoreDisplay() {
    const display = document.getElementById('player-scores');
    if (!display) return;

    if (this.gameScores.length === 0) {
      display.innerHTML = '<em style="color: #808080;">No games played yet</em>';
      return;
    }

    const scoreList = this.gameScores.map(score => `$${score}`).join(', ');
    const bestScore = Math.max(...this.gameScores);
    
    display.innerHTML = `
      <div style="margin-bottom: 4px;"><strong>Your Last ${this.gameScores.length} Games:</strong></div>
      <div style="font-size: 11px;">${scoreList}</div>
      <div style="margin-top: 4px; color: #008000; font-weight: bold;">Best: $${bestScore}</div>
    `;
  }

  async endGame(won = false) {
    this.gameOver = true;
    
    const statusMsg = document.querySelector('[data-game-status]');
    if (statusMsg) {
      if (won) {
        statusMsg.textContent = `💰 You won! Collected $${this.moneyCollected}! 💰`;
        statusMsg.style.color = '#008000';
      } else {
        statusMsg.textContent = `😈 OOPS! THE GREED TOOK OVER! Collected $${this.moneyCollected} 😈`;
        statusMsg.style.color = '#ff0000';
      }
      statusMsg.style.fontWeight = 'bold';
    }

    this.gameScores.push(this.moneyCollected);
    
    if (this.gameScores.length > 10) {
      this.gameScores.shift();
    }
    
    await this.savePlayerScores();
    this.updateScoreDisplay();
  }

  async updateGlobalLeaderboard(score) {
    try {
      // Post score to Google Sheets
      await fetch('https://script.google.com/macros/s/AKfycbxE6UyyazXthDsOW9zqM-oOPXFvwlFaVQa9oiowezLBUqgAhwfia9xWn28R7-sZ5givVg/exec', {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          game: 'greedsweeper',
          name: this.playerName,
          score: score,
          date: new Date().toISOString()
        })
      });
    } catch (error) {
      console.error('Error updating leaderboard:', error);
    }
  }

  async getGlobalLeaderboard() {
    try {
      // Add a query parameter to specify we want greedsweeper data
      const response = await fetch('https://script.google.com/macros/s/AKfycbxE6UyyazXthDsOW9zqM-oOPXFvwlFaVQa9oiowezLBUqgAhwfia9xWn28R7-sZ5givVg/exec?game=greedsweeper');
      
      // Check if response is ok
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      
      // Handle different possible response formats
      let scores = [];
      if (Array.isArray(data)) {
        scores = data;
      } else if (data.data && Array.isArray(data.data)) {
        scores = data.data;
      } else if (data.scores && Array.isArray(data.scores)) {
        scores = data.scores;
      }
      
      // Filter for greedsweeper only and format
      const greedsweeper = scores
        .filter(row => row.game === 'greedsweeper')
        .map(row => ({
          name: row.name,
          score: parseInt(row.score),
          date: row.date
        }));
      
      // Sort by score and keep top 10
      greedsweeper.sort((a, b) => b.score - a.score);
      return greedsweeper.slice(0, 10);
    } catch (error) {
      console.error('Error fetching leaderboard:', error);
      // Return empty array on error so the game still works
      return [];
    }
  }

  async showLeaderboard() {
    const leaderboard = await this.getGlobalLeaderboard();
    
    const lbWindow = document.createElement('div');
    lbWindow.className = 'win95-window active';
    lbWindow.style.width = '350px';
    lbWindow.style.maxWidth = '90vw';
    lbWindow.style.zIndex = '10001';

    let leaderboardHTML = '';
    if (leaderboard.length === 0) {
      leaderboardHTML = '<div style="text-align: center; padding: 20px; color: #808080;">No scores yet! Be the first!</div>';
    } else {
      leaderboardHTML = '<table style="width: 100%; border-collapse: collapse;">';
      leaderboardHTML += '<tr style="background: #000080; color: #ffffff;"><th style="padding: 6px; text-align: left;">Rank</th><th style="padding: 6px; text-align: left;">Name</th><th style="padding: 6px; text-align: right;">Score</th></tr>';
      
      leaderboard.forEach((entry, index) => {
        const bgColor = index % 2 === 0 ? '#ffffff' : '#dfdfdf';
        const highlight = entry.name === this.playerName ? 'font-weight: bold; color: #008000;' : '';
        leaderboardHTML += `
          <tr style="background: ${bgColor};">
            <td style="padding: 6px; ${highlight}">${index + 1}</td>
            <td style="padding: 6px; ${highlight}">${entry.name}</td>
            <td style="padding: 6px; text-align: right; ${highlight}">$${entry.score}</td>
          </tr>
        `;
      });
      leaderboardHTML += '</table>';
    }

    lbWindow.innerHTML = `
      <div class="win95-title-bar">
        <div class="win95-title-text">
          <span>🏆</span>
          Global Leaderboard
        </div>
        <div class="win95-window-controls">
          <button class="win95-btn win95-btn-close" aria-label="Close"></button>
        </div>
      </div>
      <div class="win95-window-content" style="padding: 12px;">
        <div style="margin-bottom: 12px; font-size: 13px; font-weight: bold; text-align: center; color: #000080;">
          TOP 10 HIGH SCORES
        </div>
        ${leaderboardHTML}
      </div>
    `;

    document.body.appendChild(lbWindow);

    const closeBtn = lbWindow.querySelector('.win95-btn-close');
    closeBtn.addEventListener('click', () => lbWindow.remove());

    window.Windows95Desktop.makeDraggable(lbWindow);
    window.Windows95Desktop.centerWindow(lbWindow);
  }

  async reset() {
    this.gameOver = false;
    this.moneyCollected = 0;
    await this.init();
    
    const statusMsg = document.querySelector('[data-game-status]');
    if (statusMsg) {
      statusMsg.textContent = 'Click to collect money! Right-click to flag devils.';
      statusMsg.style.color = '#000000';
      statusMsg.style.fontWeight = 'normal';
    }
  }

  openGameWindow() {
    if (this.gameWindow && document.body.contains(this.gameWindow)) {
      window.Windows95Desktop.bringToFront(this.gameWindow);
      return;
    }

    // Reset player name when opening a fresh window so name prompt works
    this.playerName = null;

    const gameWindow = document.createElement('div');
    gameWindow.className = 'win95-window active';
    gameWindow.id = 'greedsweeper-window';
    gameWindow.style.width = '320px';
    gameWindow.style.maxWidth = '90vw';

    gameWindow.innerHTML = `
      <div class="win95-title-bar">
        <div class="win95-title-text">
          <span>💰</span>
          Greedsweeper
        </div>
        <div class="win95-window-controls">
          <button class="win95-btn win95-btn-minimize" aria-label="Minimize"></button>
          <button class="win95-btn win95-btn-close" aria-label="Close"></button>
        </div>
      </div>
      <div class="win95-window-content" style="padding: 12px; max-height: 80vh; overflow-y: auto;">
        
        <!-- Name Entry Form -->
        <div id="name-entry-form" style="display: block;">
          <div style="padding: 16px; background: #ffffff; border: 2px inset #808080; margin-bottom: 12px;">
            <div style="font-weight: bold; margin-bottom: 8px; color: #000080;">🎮 WELCOME TO GREED SWEEPER!</div>
            <div style="font-size: 11px; line-height: 1.6; margin-bottom: 12px;">
              Enter your Instagram username to begin playing. Greed Sweeper will collect the scores from your last 10 games. When you press the submit button, your best score will be submitted to the 'Top 10' leaderboard. 
              <br><br>
              <strong style="color: #ff0000;">🏆 CONTEST:</strong> Whoever has the highest score on the date of February 14th at 12am will win a free shirt!
            </div>
          </div>
          <div style="margin-bottom: 12px;">
            <label style="display: block; font-size: 12px; font-weight: bold; margin-bottom: 4px;">Instagram Username:</label>
            <input 
              type="text" 
              id="player-name-input" 
              class="win95-input" 
              placeholder="@yourname"
              style="width: 100%; padding: 4px; font-family: 'MS Sans Serif', Arial, sans-serif;"
              maxlength="20"
            >
          </div>
          <div style="text-align: center;">
            <button class="win95-button win95-button-primary" id="submit-name-btn">
              Start Playing
            </button>
            <div style="margin-top: 8px;">
              <button class="win95-button" id="play-without-name-btn" style="font-size: 11px;">
                Play Without Competing
              </button>
            </div>
          </div>
        </div>

        <!-- Game Area (hidden initially) -->
        <div id="game-area" style="display: none;">
          <div style="display: flex; justify-content: space-between; margin-bottom: 12px; padding: 8px; background: #c0c0c0; border: 2px inset #808080;">
            <div style="font-size: 12px; font-weight: bold;">
              Money: <span id="money-counter">$0</span>
            </div>
            <div style="font-size: 12px; font-weight: bold;">
              Devils: ${this.totalDevils}
            </div>
          </div>

          <div id="greedsweeper-board"></div>

          <div style="margin-top: 12px; padding: 8px; background: #ffffff; border: 2px inset #808080; font-size: 11px; text-align: center;" data-game-status>
            Click to collect money! Right-click to flag devils.
          </div>

          <div style="margin-top: 12px; padding: 8px; background: #ffffff; border: 2px inset #808080; font-size: 11px;" id="player-scores">
            Loading scores...
          </div>

          <div style="margin-top: 12px; display: flex; justify-content: center; gap: 8px; flex-wrap: wrap;">
            <button class="win95-button win95-button-primary" id="reset-game">
              New Game
            </button>
            <button class="win95-button" id="submit-score" style="background: #008000; color: #ffffff;">
              📤 Submit Score
            </button>
            <button class="win95-button" id="show-leaderboard">
              🏆 Leaderboard
            </button>
            <button class="win95-button" id="close-game">
              Close
            </button>
          </div>
        </div>
      </div>
    `;

    document.body.appendChild(gameWindow);
    this.gameWindow = gameWindow;

    const closeBtn = gameWindow.querySelector('.win95-btn-close');
    const minimizeBtn = gameWindow.querySelector('.win95-btn-minimize');
    const closeGameBtn = gameWindow.querySelector('#close-game');
    const resetBtn = gameWindow.querySelector('#reset-game');
    const leaderboardBtn = gameWindow.querySelector('#show-leaderboard');
    const submitScoreBtn = gameWindow.querySelector('#submit-score');

    const closeWindow = () => {
      gameWindow.remove();
      this.gameWindow = null;
    };

    closeBtn?.addEventListener('click', closeWindow);
    minimizeBtn?.addEventListener('click', closeWindow);
    closeGameBtn?.addEventListener('click', closeWindow);
    resetBtn?.addEventListener('click', () => this.reset());
    leaderboardBtn?.addEventListener('click', () => this.showLeaderboard());
    
    submitScoreBtn?.addEventListener('click', async () => {
      if (this.gameScores.length < 10) {
        alert(`You need to play 10 games first!\n\nGames played: ${this.gameScores.length}/10`);
        return;
      }
      
      const bestScore = Math.max(...this.gameScores);
      await this.updateGlobalLeaderboard(bestScore);
      alert(`✓ Score submitted! Your best score: $${bestScore}\n\nCheck the leaderboard to see your ranking!`);
    });

    window.Windows95Desktop.makeDraggable(gameWindow);
    window.Windows95Desktop.centerWindow(gameWindow);

    this.init();
  }
}

window.greedsweeper = new Greedsweeper();

document.addEventListener('win95-open-greedsweeper', () => {
  window.greedsweeper.openGameWindow();
});